import { defineComponent, computed } from "vue";
import { p as pick } from "../../../vendor-2b2dbafd.mjs";
import { u as useRouterLinkProps, a as useRouterLink } from "../../composables/useRouterLink-48153ec5.mjs";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { u as useBem } from "../../composables/useBem-33d80128.mjs";
const _sfc_main = defineComponent({
  name: "VaListItem",
  emits: ["focus", "click"],
  props: {
    ...useRouterLinkProps,
    ...useComponentPresetProp,
    tag: { type: String, default: "div" },
    disabled: { type: Boolean, default: false }
  },
  setup(props) {
    const tabIndexComputed = computed(() => props.disabled ? -1 : 0);
    const computedClass = useBem("va-list-item", () => ({
      ...pick(props, ["disabled"])
    }));
    return {
      ...useRouterLink(props),
      tabIndexComputed,
      computedClass
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaListItem.css';
//# sourceMappingURL=VaListItem.vue_vue_type_script_lang-b221a674.mjs.map
